export default {
    getFriendRequests(state) {
        return state.friendRequests;
    },
    getOnlineStatus(state) {
        return state.onlineStatus;
    }
}
